import {cookie} from '@/utils/cookie';

const COOKIE_USER_LANDING_KEY = 'userLanding';
const COOKIE_USER_LANDING_EXPIRES = 1;

export const setUserLandingCookie = (): void => {
  const value = {url: window.location.href, date: Date.now()};
  cookie.set(COOKIE_USER_LANDING_KEY, JSON.stringify(value), {expires: COOKIE_USER_LANDING_EXPIRES});
};
